<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>预定用户登记表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams">
        <el-row>
          <el-col style="width:240px;float:left;">
            <el-form-item label="预留手机号：" prop="mobile">
              <el-input
                v-model="listParams.tel"
                size="small"
                placeholder="请输入预定手机号"
                style="width:140px;"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col style="width:57px;float:left;">
            <el-button
              size="small"
              type="primary"
              @click="searchData"
              style="margin-top:4px;"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form>
        <el-row>
          <el-col style="width:60px;float:left;">
            <el-form-item>
              <el-button size="small" type="primary" @click="addVisible = true">
                新增
              </el-button>
            </el-form-item>
          </el-col>

          <el-col style="width:100px;float:left;">
            <el-form-item>
              <el-button size="small" type="primary">
                批量导入
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="checkInTime" align="center" label="用户昵称">
        </el-table-column>

        <el-table-column
          prop="checkOutTime"
          align="center"
          label="招接待手机号"
        >
        </el-table-column>

        <el-table-column prop="" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="detailItem(scope.row.id)"
              >编辑</el-button
            >
            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要删除该条数据？"
              v-on:confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog
      title="编辑场馆服务用户登记表"
      :visible.sync="editVisible"
      style="text-align: center;"
    >
      <el-form style="width:200px;margin:auto" :model="form">
        <el-form-item>
          <el-input
            label="手机号"
            size="small"
            placeholder="请输入手机号"
            style="width:140px;"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="margin:auto;margin-top:50px;">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增人员"
      :visible.sync="addVisible"
      style="text-align: center;"
    >
      <el-form style="width:200px;margin:auto" :model="form">
        <el-form-item>
          <el-input
            label="手机号"
            size="small"
            placeholder="请输入手机号"
            style="width:140px;"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="margin:auto;margin-top:50px;">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {},
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      editVisible: false,
      addVisible: false,
      form: {},
      bodyParams: [],
      tempDate: "",
      orderId: 0
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    submitAdd() {},
    submitEdit() {},
    detailItem(id) {
      this.editVisible = true;
      this.orderId = id;
    },
    addUser() {
      this.addVisible = true;
    },
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/reception/order/list/hotelAdmin",
        method: "GET",
        params: this.bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.orders.length > 0) {
              this.tableData = res.body.data.orders;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    searchData: function() {
      this.tableLoading = false;
      const checkInTime = this.tempDate[0];
      const checkOutTime = this.tempDate[1];
      const status = parseInt(this.listParams.status);
      this.bodyParams = Object.assign({}, this.listParams, {
        status: status,
        checkInTime: checkInTime,
        checkOutTime: checkOutTime,
        tel: this.listParams.tel,
        page: this.pager.pageIndex,
        size: this.pager.pageSize
      });
      this.loadTableData();
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>
<style>
#convalescenceInfoTable {
  width: 100%;
}
#convalescenceInfoTable th {
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}
#convalescenceInfoTable td {
  font-size: 14px;
}
</style>
